import React from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface ComplianceWithLawsAndRegulationsRommsProps {
  onBack: () => void;
}

export default function ComplianceWithLawsAndRegulationsRomms({ onBack }: ComplianceWithLawsAndRegulationsRommsProps) {
  return <PayrollRomms onBack={onBack} onComplete={() => {}} workspace="Non-compliance with laws and regulations" />;
}
